import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DmarcChartSection from '../../components/domain-portfolio/dmarc-chart-section';

import { fetchAggDomainsIfNeeded } from '../../../common/actions/aggregate-domains-action-creators';

import { domainsPolicyCountsSelector } from '../../../common/selectors/domains-selectors';
import { dmarcBubbleChartIsLoadingSelector, dmarcBubbleChartSelector } from '../../../common/selectors/aggregate-domains-selectors';
import { daysInRangeSelector } from '../../selectors/reports-selectors';

export class DmarcChartSectionContainer extends Component{

    componentDidMount(){
        const { onInitialLoad } = this.props;

        onInitialLoad( true );
        this.fetchData();
    }

    componentDidUpdate( prevProps ){
        if( prevProps.daysInRange !== this.props.daysInRange ){
            this.fetchData();
        }
    }

    fetchData = ( params ) => {
        const { fetchAggDomainsIfNeeded, daysInRange } = this.props;

        fetchAggDomainsIfNeeded( { previousDays: daysInRange } );
    };

    render(){
        const { isLoading, aggDomainsData, domainsPolicyCountsData } = this.props;
        return (
            <DmarcChartSection
                isLoading={isLoading}
                domainsPolicyCountsData={domainsPolicyCountsData}
                aggDomainsData={aggDomainsData} />
        );
    };
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        aggDomainsData: dmarcBubbleChartSelector( state ),
        daysInRange: daysInRangeSelector( state ),
        domainsPolicyCountsData: domainsPolicyCountsSelector( state ),
        isLoading: dmarcBubbleChartIsLoadingSelector( state ),
    };
};

DmarcChartSectionContainer.propTypes = {
    aggDomainsData: PropTypes.array,
    daysInRange: PropTypes.number.isRequired,
    domainsPolicyCountsData: PropTypes.object,
    fetchAggDomainsIfNeeded: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onInitialLoad: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, { fetchAggDomainsIfNeeded } )( DmarcChartSectionContainer );
